import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import About from './Pages/About';
import Services from './Pages/Services';
import SalePurchase from './Pages/SalePurchase';
import BusinessSupport from './Pages/BusinessSupport';
import DigitalMarketing from './Pages/DigitalMarketing';
import RoadAssistance from './Pages/RoadAssistance';
import LeadsGeneration from './Pages/LeadsGeneration';
import CustomerServices from './Pages/CustomerServices';
import BookAppointment from './Pages/BookAppointment';
import VehicleRecovery from './Pages/VehicleRecovery';
import PartsProcurement from './Pages/PartsProcurement';
import GarageSoftwareSetup from './Pages/GarageSoftwareSetup';
import Blog from "./Pages/Blog";
import BlogArticle from "./Pages/BlogArticle";
import NotFound from "./Pages/NotFound";

// Admin panel (loaded only when someone opens /admin)
const AdminApp = lazy(() => import('./admin/AdminApp'));

function App() {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-gray-500">Loading admin…</div>}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route path="*" element={<PublicSite />} />
    </Routes>
  );
}

function PublicSite() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <ScrollToTop />

      <main className="flex-grow">
        <Routes>
          {/* Core Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-appointment" element={<BookAppointment />} />

          {/* Services */}
          <Route path="/services" element={<Services />} />
          <Route path="/services/business-support" element={<BusinessSupport />} />
          <Route path="/services/garage-software-setup" element={<GarageSoftwareSetup />} />
          <Route path="/services/sale-purchase" element={<SalePurchase />} />
          <Route path="/services/customer-services" element={<CustomerServices />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/services/parts-procurement" element={<PartsProcurement />} />
          <Route path="/services/road-assistance" element={<RoadAssistance />} />
          <Route path="/services/leads-generation" element={<LeadsGeneration />} />
          <Route path="/services/vehicle-recovery" element={<VehicleRecovery />} />

          {/* Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
